// High-performance dictionary-based food translator and transliterator for POS

const foodPhrases: { [key: string]: string } = {
  // Phrase mappings (Full Names)
  "कढ़ाई पनीर": "Kadai Paneer",
  "कढ़ाई पनीर": "Kadai Paneer",
  "शाही पनीर": "Shahi Paneer",
  "मटर पनीर": "Matar Paneer",
  "पालक पनीर": "Palak Paneer",
  "पनीर बटर मसाला": "Paneer Butter Masala",
  "पनीर टिक्का": "Paneer Tikka",
  "दाल मखनी": "Dal Makhani",
  "दाल तड़का": "Dal Tadka",
  "दाल फ्राई": "Dal Fry",
  "बटर चिकन": "Butter Chicken",
  "कढ़ाई चिकन": "Kadai Chicken",
  "चिकन करी": "Chicken Curry",
  "चिकन बिरयानी": "Chicken Biryani",
  "वेज बिरयानी": "Veg Biryani",
  "आलू पराठा": "Aloo Paratha",
  "प्याज पराठा": "Onion Paratha",
  "पनीर पराठा": "Paneer Paratha",
  "गोभी पराठा": "Gobhi Paratha",
  "तंदूरी रोटी": "Tandoori Roti",
  "रूमाली रोटी": "Rumali Roti",
  "बटर नान": "Butter Naan",
  "लच्छा पराठा": "Lachha Paratha",
  "जीरा राइस": "Jeera Rice",
  "प्लेन राइस": "Plain Rice",
  "वेज पुलाव": "Veg Pulao",
  "गुलाब जामुन": "Gulab Jamun",
  "रसमलाई": "Rasmalai",
  "गाजर का हलवा": "Gajar Halwa",
  "मसाला डोसा": "Masala Dosa",
  "प्लेन डोसा": "Plain Dosa",
  "इडली सांभर": "Idli Sambar",
  "सिरका प्याज": "Sirka Onion",
  "हरी चटनी": "Green Chutney",
  "बूंदी रायता": "Boondi Raita",
  "मिक्स वेज रायता": "Mix Veg Raita",
  "सब्जी": "Veg Mix",
  "मिक्स वेज": "Mix Veg"
};

const foodWords: { [key: string]: string } = {
  // Word mappings
  "पनीर": "Paneer",
  "रोटी": "Roti",
  "नान": "Naan",
  "चिकन": "Chicken",
  "मटन": "Mutton",
  "अंडा": "Egg",
  "मछली": "Fish",
  "करी": "Curry",
  "सब्जी": "Veg",
  "सब्जियां": "Vegetables",
  "दाल": "Dal",
  "चावल": "Rice",
  "आलू": "Aloo",
  "गोभी": "Gobhi",
  "प्याज": "Onion",
  "टमाटर": "Tomato",
  "मशरूम": "Mushroom",
  "मलाई": "Malai",
  "कोफ्ता": "Kofta",
  "बटर": "Butter",
  "मक्खन": "Butter",
  "घी": "Ghee",
  "तंदूरी": "Tandoori",
  "कढ़ाई": "Kadai",
  "शाही": "Shahi",
  "जीरा": "Jeera",
  "समोसा": "Samosa",
  "कचौड़ी": "Kachori",
  "पकोड़ा": "Pakoda",
  "पकोड़े": "Pakode",
  "रायता": "Raita",
  "सलाद": "Salad",
  "चटनी": "Chutney",
  "पापड़": "Papad",
  "पुलाव": "Pulao",
  "बिरयानी": "Biryani",
  "लस्सी": "Lassi",
  "मसाला": "Masala",
  "चाय": "Tea",
  "कॉफ़ी": "Coffee",
  "पानी": "Water",
  "दूध": "Milk",
  "चीनी": "Sugar",
  "नमक": "Salt",
  "नींबू": "Lemon",
  "मिर्च": "Chili",
  "मसालेदार": "Spicy",
  "मीठा": "Sweet",
  "डेसर्ट": "Dessert",
  "सूप": "Soup",
  "वेज": "Veg",
  "नॉन-वेज": "Non-Veg",
  "दही": "Curd",
  "गुलाब": "Gulab",
  "जामुन": "Jamun",
  "डोसा": "Dosa",
  "इडली": "Idli",
  "सांभर": "Sambar",
  "वड़ा": "Vada",
  "उत्तपम": "Uttapam",
  "पिज्जा": "Pizza",
  "बर्गर": "Burger",
  "नूडल्स": "Noodles",
  "फ्राइज़": "Fries",
  "सैंडविच": "Sandwich",
  "रोल": "Roll",
  "मोमोज": "Momos",
  "मंचूरियन": "Manchurian",
  "सॉस": "Sauce",
  "चटपटा": "Spicy",
  "हाफ": "Half",
  "फुल": "Full",
  "प्लेट": "Plate",
  "पीस": "Piece",
  "कढ़ी": "Kadhi"
};

const devanagariConsonants = [
  'क','ख','ग','घ','ङ',
  'च','छ','ज','झ','ञ',
  'ट','ठ','ड','ढ','ण',
  'त','थ','द','ध','न',
  'प','फ','ब','भ','म',
  'य','र','ल','व','श','ष','स','ह',
  'ड़','ढ़','क्ष','त्र','ज्ञ'
];

const devanagariVowelSigns = [
  'ा','ि','ी','ु','ू','ृ','े','ै','ो','ौ','्'
];

const devanagariMapping: { [key: string]: string } = {
  'अ': 'a', 'आ': 'aa', 'इ': 'i', 'ई': 'ee', 'उ': 'u', 'ऊ': 'oo', 'ऋ': 'ri', 'ए': 'e', 'ऐ': 'ai', 'ओ': 'o', 'औ': 'au',
  'क': 'ka', 'ख': 'kha', 'ग': 'ga', 'घ': 'gha', 'ङ': 'nga',
  'च': 'cha', 'छ': 'chha', 'ज': 'ja', 'झ': 'jha', 'ञ': 'nya',
  'ट': 'ta', 'ठ': 'tha', 'ड': 'da', 'ढ': 'dha', 'ण': 'na',
  'त': 'ta', 'थ': 'tha', 'द': 'da', 'ध': 'dha', 'न': 'na',
  'प': 'pa', 'फ': 'pha', 'ब': 'ba', 'भ': 'bha', 'म': 'ma',
  'य': 'ya', 'र': 'ra', 'ल': 'la', 'व': 'va', 'श': 'sha', 'ष': 'sha', 'स': 'sa', 'ह': 'ha',
  'ड़': 'da', 'ढ़': 'dha', 'क्ष': 'ksh', 'त्र': 'tr', 'ज्ञ': 'gy',
  'ा': 'a', 'ि': 'i', 'ी': 'ee', 'ु': 'u', 'ू': 'oo', 'ृ': 'ri', 'े': 'e', 'ै': 'ai', 'ो': 'o', 'ौ': 'au',
  'ं': 'n', 'ः': 'h', 'ँ': 'm', '्': '', '़': ''
};

// Check if a string contains Hindi/Devanagari characters
export const isHindiText = (text: string): boolean => {
  return /[\u0900-\u097F]/.test(text);
};

// Phonetic Devanagari to Latin Transliteration Fallback
const transliterateDevanagari = (text: string): string => {
  let result = '';
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const nextChar = text[i + 1];

    if (char === '्') {
      if (result.endsWith('a')) {
        result = result.slice(0, -1);
      }
      continue;
    }

    if (devanagariMapping[char] !== undefined) {
      let mapped = devanagariMapping[char];
      
      // If it's a consonant and has a vowel sign after it, drop the inherent 'a'
      if (devanagariConsonants.includes(char)) {
        if (nextChar && devanagariVowelSigns.includes(nextChar)) {
          mapped = mapped.slice(0, -1);
        }
      }
      result += mapped;
    } else {
      result += char;
    }
  }

  // Capitalize beautifully
  return result.charAt(0).toUpperCase() + result.slice(1);
};

// Translates a Hindi food item name to English
export const translateHindiToEnglish = (text: string): string => {
  if (!text || !isHindiText(text)) return text;
  
  const trimmed = text.trim();
  
  // 1. Check full phrase dictionary
  if (foodPhrases[trimmed]) {
    return foodPhrases[trimmed];
  }
  
  // 2. Try splitting into words and translating word-by-word
  const words = trimmed.split(/\s+/);
  const translatedWords = words.map(word => {
    // Check if the word is in the dictionary
    if (foodWords[word]) {
      return foodWords[word];
    }
    // Fallback to phonetic Devanagari transliteration
    return transliterateDevanagari(word);
  });
  
  return translatedWords.join(' ');
};
